module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/g6feb7/tc-custom/9780544317901.jpg?1700958420892",
      "alt": "This image is the cover for the book Book of Souls, The Detective Inspector McLean Novels"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Book of Souls, The Detective Inspector McLean Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("When an Edinburgh serial killer is murdered in prison, his deadly legacy lives on to claim more victims in this “engrossing” Scottish detective mystery ("), _c('i', [_vm._v("Publishers Weekly")]), _vm._v(").")])]), _c('p', [_vm._v("For ten years, a gruesome Christmastime tradition terrorized Edinburgh. Each year as the holiday approached, a young woman’s body was found—naked, throat slit, body washed clean. The final victim, Kirsty Summers, was Detective Constable Tony McLean's fiancée. But the Christmas Killer made a mistake, and McLean finally put an end to the horror.")]), _c('p', [_vm._v("Now, twelve years later, a fellow prisoner has just murdered the incarcerated Christmas Killer. But with the arrival of the festive season comes a body. A young woman: naked, washed, her throat cut. Is this a copycat killer? Was the wrong man behind bars all this time? Or is there a more frightening explanation? McLean must revisit the most disturbing case of his life and discover what he missed before the killer strikes again.")]), _c('b', [_vm._v("“Oswald’s detective gives John Rebus a run for his money in this noirish page-turner.”—"), _c('i', [_vm._v("Kirkus")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James Oswald\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("JAMES OSWALD is the author of the Detective Inspector McLean series of crime novels by night. During the day he runs a 350 acre livestock farm in North East Fife, Scotland where he raises Highland cattle and sheep.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (hmhbooks.com)\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0